import md5 from "blueimp-md5";
import { firebase } from "@firebase/app";
import "@firebase/auth";

export default {
    ["DELETE_TAX"](state, payload) {
        state.invoice.taxes.splice(payload, 1)
    },
    ["ADD_TAX"](state, payload) {
        let a = {}
        a.name = payload.fname
        a.amount = payload.famount
        a.type = payload.ftype
        state.invoice.taxes.push(a)
    },
    ["DELETE_PRODUCT"](state, payload) {
        state.invoice.items.splice(payload, 1)
    },
    ["ADD_PRODUCT"](state, payload) {
        let a = {}
        a.name = payload.fname
        a.qty = payload.fqty
        a.price = payload.fprice
        a.ref = payload.fref
        state.invoice.items.push(a)
    },
    ["NEXT_STEP"](state) {
        state.e1 = state.e1 + 1;
    },
    ["PREV_STEP"](state) {
        state.e1 = state.e1 - 1;
    },
    ["TOOGLE_NAVBAR_ACTIONS"](state) {
        state.showNavActionButtons = !state.showNavActionButtons;
    },
    ["SET_INVOICE"](state, payload) {
        state.invoice = payload;
    },
    ["UPDATE_SNACK"](state, payload) {
        state.snack.show = true;
        switch (payload) {
            case "success":
                state.snack.color = payload;
                state.snack.text = "Data saved";
                break;
            case "update":
                    state.snack.color = "success";
                    state.snack.text = "Data updated";
                    break;
            case "danger":
                state.snack.color = payload;
                state.snack.text = "Data removed";
                break;

            default:
                break;
        }

    },
    ["UPDATE_MODAL"](state, payload){
        state.modal.show = true;
        state.modal.title = payload.title;
        state.modal.content =payload.content;
        state.modal.password  =payload.password;
        state.modal.url  =payload.url;
        state.modal.type =payload.type;
    },
    ["SET_USER"](state, payload) {
        state.user = payload.user
    },
    ["TOOGLE_FETCHING"](state) {
        state.fetching = !state.fetching;
    },
    ["TOOGLE_SIDEBAR"](state,payload) {
        state.sidebar = payload;
    },
    ["UPDATE_SUB_TOTAL"](state,payload) {
        state.invoice.sub_total = payload;
    },
    ["UPDATE_TOTAL"](state,payload) {
        state.invoice.total = payload;
    },
    ["INIT_STEPPER"](state) {
        state.e1 = 1;
    },
    ["UPDATE_AVATAR"](state,payload) {
        state.avatar.show = payload.show;
        state.avatar.url = "https://www.gravatar.com/avatar/" + md5(payload.email);
    },
    ["SET_USER_INVOICES"](state,payload) {
        state.invoices = payload;
    },
    ["LOGOUT"](state) {
        state.avatar.show = false
        state.userProfile = {}
        firebase.auth().signOut();
    },
    ["RESET_STATE_DEFAULT"](state) {
        const s = initialState()
        if(Object.keys(state.userProfile).length > 0){
            s.invoice.from = state.userProfile
        }else{
            s.invoice.from = state.invoice.from
        }
        
        Object.keys(s).forEach(key => {
          state[key] = s[key]
        })
    },
    ["SET_SAVE_BUTTON_STATUS"](state,payload) {
        state.buttons.save = payload;
    },
    ["SET_USER_PROFILE"](state,payload) {
        state.userProfile = payload;
    },
}

function initialState () {
    return {   
        fetching : false,
        buttons : {
            save : false,
        },
        sidebar : false,
        e1 : 1,
        modal : {
            show : false, 
            title : "", 
            content : "", 
            url : null,
            password : false
        },
        snack: {
            show : false,
            color :"",
            text: "",
        } ,
        showNavActionButtons : false,
        invoice: {
            number:1,
            logo :"",
            type : "",
            date : new Date().toISOString().substr(0, 10),
            dueDate : new Date((new Date()).getTime() + (60*60*24*1000)).toISOString().substr(0, 10),
            dialog: false,
            taxTypes: ["rate", "amount"],
            currencies: ["DZD", "USD", "EUR"],
            snack: false,
            snackColor: "",
            snackText: "",
            items : [],
            taxes : [],
            from : {
                name :'',
                email:'',
                address:"",
                details :""
            },
            to : {
                name :'',
                email:'',
                address:"",
                details :""
            },
            is_private: false,
            password: "",
            user_id :"",
            sub_total: 0,
            total: 0,
        } 
    }
  }
  